
$('form.trainings #search-order').on('change', function() {
    fillTrainingsInputs();
    $('form.filter button').click();
});

// Search Form
$( ".filter-section .filter .item" ).each(function(index) {
    $(this).on("click", function(){
        $( this ).toggleClass( "selected appear disappear" );
    });
});

// select all
$( ".filter-section .filter .select-toggle .select" ).each(function(index) {
    $(this).on("click", function(){
        $(this).closest(".card-body").find('.grid-wrapper').find('.item').each(function(index) {
            $( this ).removeClass("disappear");
            $( this ).addClass("selected appear");
        });
        filterByTerms();
    });
});

// unselect all
$( ".filter-section .filter .select-toggle .unselect" ).each(function(index) {
    $(this).on("click", function(){
        $(this).closest(".card-body").find('.grid-wrapper').find('.item').each(function(index) {
            $( this ).removeClass("selected appear");
            $( this ).addClass("disappear");
        });
        filterByTerms();
    });
});

function getTrainingsTerms(containerID) {
    let terms = [];
    if ($( containerID + ' .item' ).length < 1) {
        return [];
    }
    $( containerID + ' .item' ).each(function(index, item) {
        if ($(item).hasClass('appear')) {
            terms.push($(item).attr('data-term').replace('lf-', '').replace(' ', '').toLowerCase());
        }
    });
    return terms;
}

// show or hide results, based on selected items
function filterByTrainingsTerms() {
    let academic = getTrainingsTerms('.filter #collapse1-4');
    let target = getTrainingsTerms('.filter #collapse1-3');
    let topic = getTrainingsTerms('.filter #collapse1-2');
    let type = getTrainingsTerms('.filter #collapse1-1');

    $('.container .training').each(function(i, el) {
        let hitAcademic = false;
        let hitTarget = false;
        let hitTopic = false;
        let hitType = false;

        let elAcademic = $(el).attr('data-academic').split(' ');
        let elTarget = $(el).attr('data-target').split(' ');
        let elTopic = $(el).attr('data-topic').split(' ');
        let elType = $(el).attr('data-type').split(' ');

        $(elAcademic).each(function(index, item) {
            item = item.replace(' ', '').toLowerCase();
            if (item !== '') {
                if (academic.filter(x => x === item).length > 0) {
                    hitAcademic = true;
                }
            }
        });

        $(elTarget).each(function(index, item) {
            item = item.replace(' ', '').toLowerCase();
            if (item !== '') {
                if (target.filter(x => x === item).length > 0) {
                    hitTarget = true;
                }
            }
        });

        $(elTopic).each(function(index, item) {
            item = item.replace(' ', '').toLowerCase();
            if (item !== '') {
                if (topic.filter(x => x === item).length > 0) {
                    hitTopic = true;
                }
            }
        });

        $(elType).each(function(index, item) {
            item = item.replace(' ', '').toLowerCase();
            if (item !== '') {
                if (type.filter(x => x === item).length > 0) {
                    hitType = true;
                }
            }
        });

        if (hitType || hitTopic || hitTarget || hitAcademic) {
                $(el).attr('style', 'display: flex !important');
        } else {
            $(el).attr('style', 'display: none !important');
        }
    });
}

if ($( 'form.trainings .filter #collapse1-1' ).length > 0) {
    $('form.trainings .filter #collapse1-1 .item').on('click', function (item) {
        filterByTrainingsTerms();
    });
}

if ($( 'form.trainings .filter #collapse1-2' ).length > 0) {
    $('form.trainings filter #collapse1-2 .item').on('click', function (item) {
        filterByTrainingsTerms();
    });
}

if ($( 'form.trainings .filter #collapse1-3' ).length > 0) {
    $('form.trainings .filter #collapse1-3 .item').on('click', function (item) {
        filterByTrainingsTerms();
    });
}

if ($( 'form.trainings .filter #collapse1-4' ).length > 0) {
    $('form.trainings .filter #collapse1-4 .item').on('click', function (item) {
        filterByTrainingsTerms();
    });
}

function fillTrainingsInputs() {
    let academic = [];
    let target = [];
    let topic = [];
    let type = [];

    $( '#collapse1-1 .item' ).each(function(index, item) {
        if ($(item).hasClass('appear')) {
            type.push($(item).attr('data-term').replace(' ', ''));
        }
    });

    if ($( '#collapse1-2' ).length > 0) {
        $('#collapse1-2 .item').each(function (index, item) {
            if ($(item).hasClass('appear')) {
                topic.push($(item).attr('data-term').replace(' ', ''));
            }
        });
    }

    if ($( '#collapse1-3' ).length > 0) {
        $('#collapse1-3 .item').each(function (index, item) {
            if ($(item).hasClass('appear')) {
                target.push($(item).attr('data-term'));
            }
        });
    }

    if ($( '#collapse1-4' ).length > 0) {
        $('#collapse1-4 .item').each(function (index, item) {
            if ($(item).hasClass('appear')) {
                academic.push($(item).attr('data-term'));
            }
        });
    }

    $('#form_type').val(type.join(','));
    $('#form_topic').val(topic.join(','));
    $('#form_target').val(target.join(','));
    $('#form_academic').val(academic.join(','));
    $('#form_most_searched').val($('#most-searched').val());
    $('#form_order').val($('#search-order').val());
    $('#form_search_query').val($('#search-query').val());
}

// form submit handling
$( "form.trainings").on("submit", function(ev){
    fillTrainingsInputs();
});

jQuery(document).ready(function($) {
    if (window.location.hash != null && window.location.hash !== '') {
        $('html,body').animate({scrollTop:$(window.location.hash).offset().top - 110}, 500);
    }
});
